module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bg-color"
  }, [_c('div', {
    staticClass: "container blog-display"
  }, [_c('div', {
    staticClass: "inner-blog"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "about-blog"
  }, [_c('h1', {
    staticClass: "blog_title"
  }, [_vm._v(_vm._s(_vm.fetchedData.attributes.title))]), _vm._v(" "), _c('div', {
    staticClass: "blog_content"
  }, [_c('big', {
    domProps: {
      "innerHTML": _vm._s(this.$options.filters.convertUrlImage(_vm.fetchedData.attributes.description))
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('popular')], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05e1a41b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = 295
// module chunks = 1